import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadMario = () => {
    const promiseMario = new Promise((resolve, reject) => {
        loader.load(
            "office/model/mario/Meshy_AI_Mario_0310200231_texture.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(-1.6871821637937012, 2.7559995996837263, 9.899584556085877);
                model.scale.set(0.20, 0.20, 0.20);
                model.rotation.set(3.141592653589793, -0.02793671950825484, 3.141592653589793);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseMario;
};

export { loadMario };
